import { LDUser } from 'launchdarkly-js-client-sdk'
import { DecodedToken } from '@wm-front/shared/interfaces'

/** Extract the datetime out of the 48-timeslot-hours based time
 * @param { number } selectedValue a float hour 13h30 <=> 55
 */
export function getFeatureFlagUser(decodedToken: DecodedToken | null): LDUser {
  let user: LDUser = {}

  if (decodedToken) {
    const id =
      typeof decodedToken.id === 'string'
        ? decodedToken.id
        : decodedToken.id !== undefined && decodedToken.id >= 0
        ? decodedToken.id.toString()
        : undefined
    const payload: {
      [key: string]: string | number | boolean | (string | number | boolean)[]
    } = {}

    Object.keys(decodedToken.payload).forEach((key) => {
      if (decodedToken.payload[key] !== undefined) {
        payload[key] = decodedToken.payload[key]
      }
    })

    if (id) payload['id'] = id

    user = {
      key: decodedToken.email,
      email: decodedToken.email,
      name: decodedToken.name ? decodedToken.name : undefined,
      custom: {
        ...payload,
      },
    }
  }

  return user
}
